import { StyledAppBar, Toolbar } from './index.styles';

const AppBar = () => (
  <StyledAppBar position='static' elevation={0}>
    <Toolbar />
  </StyledAppBar>
);

export default AppBar;
